export default {
    SET_ITEMS(state, payload) {
        state.items = payload;
    },
}